import { useBulkPricingActionsPermissions } from 'src/components/common/BulkActions/BulkPricingActions/useBulkPricingActionsPermissions';
import { Content } from 'src/contexts/ContentContext';
import { PosDropdownItem } from 'src/core/POS/PosDropdown';
import { ContentId } from 'src/utils/constants/contentId';

export const LaunchEditAutoPricingSettings = ({
  onClick,
  disabled,
}: {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}) => {
  const { hasAutoPricingFeature, hasEditPricingPermission } =
    useBulkPricingActionsPermissions();

  if (!hasAutoPricingFeature || !hasEditPricingPermission) {
    return null;
  }

  return (
    <PosDropdownItem
      key={'AutoPricingSettings'}
      onClick={onClick}
      disabled={disabled}
    >
      <Content id={ContentId.AutopricingSettings} />
    </PosDropdownItem>
  );
};
